import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { Filter } from '../../../components/_WMS/FilterComponent'

export const getProcessList = (filters?: Filter[], page = 0, pageSize = 5) => {
  const url = new URL(`${ApiConfig.ProcessApi}`)
  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.set(element.key, element.value)
    })
  }

  return axios.get(url.toString())
}

export const getUrlResultFile = (processId: number) => {
  const url = new URL(`${ApiConfig.ProcessApi}/GetResultFile/${processId}`)
  return axios.get(url.toString())
}

export const getUrlOriginalFile = (processId: number) => {
  const url = new URL(`${ApiConfig.ProcessApi}/GetFile/${processId}`)
  return axios.get(url.toString())
}
